export default __webpack_public_path__ + "static/BrownEntrataTT-Light-fbd9e8adb9f7a805c056ad31c7fa0f71.ttf";